


<div class="gerenciador-jobs-impressao">
  <!-- Header -->
  <!-- <div class="section-header">
    <div class="header-content">

      <ng-container *ngIf="servidorImpressao">
        <h5>Gerenciamento de Jobs de Impressão</h5>

      </ng-container>

      <ng-container *ngIf="!servidorImpressao">
        <h5>Jobs de Impressão</h5>
      </ng-container>


    </div>
  </div>-->

  <!-- Indicador de modo visualização -->
  <div class="tab-status-indicator" *ngIf="!isMasterTab()">
    <div class="alert alert-info">
      <i class="fe-info"></i>
      <strong>Modo Visualização:</strong> Outra aba está gerenciando a impressão.
      Esta aba mostra apenas o status dos jobs.
    </div>
  </div>

  <!-- Cards das impressoras (apenas na aba ativos) -->
  <div class="impressoras-cards" *ngIf="qzConectado && impressorasConfiguradas.length > 0">
    <div class="row">
      <span>{{verificarStatusImpressoras()}}</span>
      <div *ngFor="let impressora of impressorasConfiguradas" class="col-md-6 col-lg-4  ">
        <div class="card impressora-card" [class.disponivel]="impressora.disponivelQzTray" [class.indisponivel]="!impressora.disponivelQzTray">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="impressora-icon">
                <i class="fe-printer"></i>
              </div>
              <div class="impressora-info flex-grow-1">
                <h6 class="card-title mb-1">{{impressora.setor}}</h6>
                <small class="text-muted">{{impressora.nome}}</small>
              </div>
              <div class="impressora-status"  >
                <span class="badge" [class.badge-success]="impressora.disponivelQzTray" [class.badge-danger]="!impressora.disponivelQzTray">
                  <i class="fe-check-circle" *ngIf="impressora.disponivelQzTray"></i>
                  <i class="fe-x-circle" *ngIf="!impressora.disponivelQzTray"></i>

                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container  *ngIf="servidorImpressao && !qzConectado">
    <app-qztray-detect (onConectou)="conectouQzTray()"  ></app-qztray-detect>
  </ng-container>

  <!-- Abas -->
  <div class="abas-container">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <a class="nav-link" [class.active]="abaAtiva === 'pendentes'"
           (click)="alterarAba('pendentes')" role="tab">
          <i class="fe-activity"></i> Pendentes
          <span class="badge badge-primary ml-2" *ngIf="this.servidorExecutor.totalJobsPendentes">
            {{this.servidorExecutor.totalJobsPendentes}}</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="abaAtiva === 'historico'"
           (click)="alterarAba('historico')" role="tab">
          <i class="fe-clock"></i> Finalizados
        </a>
      </li>
    </ul>
  </div>

  <div class="alert alert-success" *ngIf="mensagemSucesso">
    <i class="fe-check-circle"></i> {{mensagemSucesso}}
    <button type="button" class="close" (click)="limparMensagens()">
      <span>&times;</span>
    </button>
  </div>

  <div class="alert alert-danger" *ngIf="erro">
    <i class="fe-alert-triangle"></i> {{erro}}
    <button type="button" class="close" (click)="limparMensagens()">
      <span>&times;</span>
    </button>
  </div>

  <!-- Filtros -->
  <div class="filtros-section mt-2">
    <div class="row">
      <div class="col-md-3">
        <label>Status</label> {{filtroStatus}}
        <select class="form-control form-control-sm" name="filtroStatus" [(ngModel)]="filtroStatus" (change)="apliqueFiltros()">
          <option *ngFor="let status of statusDisponiveis" [value]="status.valor">
            {{status.label}}
          </option>
        </select>
      </div>
      <!--<div class="col-md-3">
        <label>Servidor</label>
        <input type="text" class="form-control form-control-sm"
               [(ngModel)]="filtroServidor"
               placeholder="Filtrar por servidor"
               (keyup.enter)="apliqueFiltros()">
      </div> -->
      <div class="col-md-3" *ngIf="impressorasConfiguradas.length > 1">
        <label>Impressora</label> {{filtroImpressora}}

        <select class="form-control form-control-sm"  name="filtroImpressora" [(ngModel)]="filtroImpressora" (change)="apliqueFiltros()">
          <option *ngFor="let impressora of impressorasConfiguradas" [value]="impressora.id">
            <ng-container *ngIf="impressora.setor != impressora.nome">
              {{impressora.setor}} -
            </ng-container>
             {{impressora.nome}}
          </option>
        </select>

      </div>

      <div class="col-md-3 d-flex align-items-end" *ngIf="temFiltro()">
        <button class="btn btn-sm btn-outline-secondary" (click)="limpeFiltros()">
          <i class="fe-x"></i> Limpar
        </button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div class="text-center py-4" *ngIf="carregando">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
    <p class="mt-2 text-muted">Carregando jobs de impressão...</p>
  </div>

  <!-- Conteúdo das abas -->
  <div class="tab-content">

    <!-- Aba Jobs Ativos -->
    <div class="tab-pane active"   *ngIf="abaPendentesAtiva()">
      <div class="row" *ngIf="!carregando">
        <div class="col-12">
          <div class="header-actions mt-2 mr-3 float-right">
            <span class="badge badge-primary mr-2">{{servidorExecutor.totalJobsPendentes}} jobs pendentes</span>
            <button class="btn btn-sm btn-outline-secondary" (click)="recarregueJobs()" [disabled]="carregando">
              <i class="fe-refresh-cw" [class.fe-spin]="carregando"></i>
              Atualizar
            </button>
          </div>
        </div>

        <div class="col-12">
          <!-- Lista de Jobs Ativos -->
          <div class="jobs-list"  >
              <div class="job-item" *ngFor="let job of jobs" [class]="'job-' + job.status.toLowerCase()"
                [hidden]="job.concluido || job.ocultar">
                <div class="job-header" (click)="toogleJob(job)" style="cursor: pointer;">
                  <div class="job-status">
                    <span class="status-icon">
                      <i class="k-icon k-i-loading" *ngIf="job.processando"></i>
                      <span *ngIf="!job.processando">{{obtenhaStatusIcon(job.status)}}</span>
                    </span>
                    <span class="status-label" [class]="obtenhaStatusClass(job.status)" [class.timeout-warning]="jobComTimeout(job)">
                      {{obtenhaStatusLabel(job.status)}}
                      <span *ngIf="jobComTimeout(job)" class="timeout-indicator">
                        <i class="fe-alert-triangle"></i> Lento
                      </span>
                    </span>

                    <span class="badge badge-blue" *ngIf="job.pedido">#{{job.pedido.codigo}}</span>
                    <ng-container *ngIf="job.comanda">
                      <span class="badge badge-blue">#{{job.comanda?.id}}</span>
                      <span class="badge badge-green ml-2">Mesa {{job.comanda.mesa?.nome}}</span>
                    </ng-container>


                  </div>

                  <div class="job-actions" (click)="$event.stopPropagation()"  *ngIf=" servidorMaster() && job.status != 'CANCELADO' ">
                    <!-- Botão de Cancelar para Jobs Pendentes/Na Fila -->
                    <button class="btn btn-xs btn-outline-danger"  [disabled]="job.cancelando"
                            *ngIf="!job.impresso && !job.processando"
                            (click)="cancelarJob(job)"
                            title="Cancelar job">
                      <i class="fe-x"></i> Cancelar
                    </button>

                    <!-- Botão de Reexecutar para Jobs com Erro -->
                    <button class="btn btn-xs btn-outline-warning"
                            *ngIf="job.status === 'ERRO'"  [disabled]="job.processando"
                            (click)="reexecutarJob(job)"
                            title="Reexecutar job">
                      <i class="fe-refresh-cw ml-1" [hidden]="job.processando"></i>
                      <i class="k-icon k-i-loading ml-1" *ngIf="job.processando"></i>
                      Reexecutar
                    </button>

                    <!-- Toggle seta direita -->
                    <span class="toggle-icon" (click)="toogleJob(job); $event.stopPropagation()" kendoTooltip
                          title="Clique para {{estaExpandido(job) ? 'recolher' : 'expandir'}}">
                        <i class="fe-chevron-down" *ngIf="estaExpandido(job)"></i>
                        <i class="fe-chevron-right" *ngIf="!estaExpandido(job)"></i>
                   </span>
                  </div>
                </div>

                <div class="job-content" *ngIf="estaExpandido(job)">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="info-group">
                        <label>Tipo</label>
                        <span class="info-value">{{job.tipo}}
                         <b> {{job.pedido?.codigo}}</b>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-group">
                        <label>Servidor</label>
                        <span class="info-value">
                      <i class="fe-server"></i>
                          {{job.servidorImpressao?.nome || 'Não atribuído'}}
                    </span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-group">
                        <label>Impressora</label>
                        <span class="info-value">
                      <i class="fe-printer"></i>
                          {{job.impressora?.nome || 'Não definida'}}
                    </span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-group">
                        <label>Prioridade</label>
                        <span class="info-value">
                      <i class="fe-flag"></i>
                          {{job.prioridade === 1 ? 'Alta' : job.prioridade === 2 ? 'Normal' : 'Baixa'}}
                    </span>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-5">
                      <div class="info-group">
                        <label>Criado em</label>
                        <span class="info-value">
                      <i class="fe-calendar"></i>
                          {{job.criadoEm | date:'dd/MM/yyyy HH:mm'}}
                    </span>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="info-group">
                        <label>Processado em</label>
                        <span class="info-value">
                      <i class="fe-clock"></i>
                          {{job.processadoEm ? (job.processadoEm | date:'dd/MM/yyyy HH:mm') : 'Não processado'}}
                    </span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-group">
                        <label>Tentativas</label>
                        <span class="info-value">
                      <i class="fe-repeat"></i>
                          {{job.tentativas}}
                    </span>
                      </div>
                    </div>
                    <div class="col-12">
                      <small>Job Id: <b>{{job.id}}</b></small>
                    </div>
                  </div>

                  <!-- Erro (se houver) -->
                  <div class="row mt-2" *ngIf="job.erro">
                    <div class="col-12">
                      <div class="alert alert-danger">
                        <i class="fe-alert-triangle"></i>
                        <strong>Erro:</strong> {{job.erro}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <!-- Sem Jobs Ativos -->
          <div class="text-center py-4" *ngIf="!carregando && servidorExecutor.totalJobsPendentes === 0">
            <i class="fe-inbox text-muted" style="font-size: 3rem;"></i>
            <p class="mt-2 text-muted">Nenhum job</p>
            <small class="text-muted">Os jobs pendentes aparecerão aqui quando houver pedidos para imprimir</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Aba Histórico -->
    <div class="tab-pane active"   *ngIf="abaHitoricoAtiva()">
      <div class="row" *ngIf="!carregandoHistorico">
        <div class="col-12">
          <div class="header-actions mt-2 mr-3 float-right">
            <span class="badge badge-secondary mr-2">Página {{paginaAtual}} de {{totalPaginas}}</span>
            <button class="btn btn-sm btn-outline-secondary" (click)="carregarHistorico()" [disabled]="carregandoHistorico">
              <i class="fe-refresh-cw" [class.fe-spin]="carregandoHistorico"></i>
              Atualizar
            </button>
          </div>
        </div>

        <div class="col-12">
          <!-- Lista de Jobs do Histórico -->
          <div class="jobs-list" *ngIf="jobsHistorico.length > 0">
            <div class="job-item job-concluido" *ngFor="let job of jobsHistorico">
              <div class="job-header" (click)="toogleJobHistorico(job)" style="cursor: pointer;">
                <div class="job-status">
                  <span class="status-icon">{{obtenhaStatusIcon(job.status)}}</span>
                  <span class="status-label" [class]="obtenhaStatusClass(job.status)">
                    {{obtenhaStatusLabel(job.status)}}
                  </span>
                  <span class="badge badge-blue mr-1" *ngIf="job.pedido">#{{job.pedido?.codigo}}</span>
                  <ng-container *ngIf="job.comanda?.id">
                    <span class="badge badge-blue">#{{job.comanda?.id}}</span>
                    <span class="badge badge-warning ml-1 mr-1">Mesa {{job.comanda.mesa?.nome}}</span>
                  </ng-container>

                  <span class="font-11 text-muted"><i>{{job.criadoEm  | date: 'dd/MM/YY HH:mm:ss'}}</i></span>

                </div>

                <div class="job-actions" (click)="$event.stopPropagation()">
                  <!-- Botão de Reimpressão para Jobs Concluídos -->

                  <span class="badge badge-dark">{{job.impressora?.setor}}</span>
                  <button class="btn btn-xs btn-outline-blue" kendoTooltip
                          *ngIf="servidorImpressao"
                          (click)="reimprimirJob(job)"
                          title="Reimprimir">
                    <i class="fe-printer"></i>

                  </button>

                  <!-- Toggle seta direita -->
                  <span class="toggle-icon" (click)="toogleJobHistorico(job); $event.stopPropagation()" kendoTooltip
                        title="Clique para {{estaExpandidoHistorico(job) ? 'recolher' : 'expandir'}}">
                    <i class="fe-chevron-down" *ngIf="estaExpandidoHistorico(job)"></i>
                    <i class="fe-chevron-right" *ngIf="!estaExpandidoHistorico(job)"></i>
                  </span>
                </div>
              </div>

              <div class="job-content" *ngIf="estaExpandidoHistorico(job)">
                <div class="row">
                  <div class="col-md-3">
                    <div class="info-group">
                      <label>Tipo</label>
                      <span class="info-value" >
                        <a [routerLink]="'/admin/pedidos/detalhes/' + job.pedido?.guid" *ngIf="job.pedido?.id">
                         {{job.tipo}}  <b> {{job.pedido?.codigo}}</b></a>

                        <ng-container *ngIf="job.comanda?.id">
                          <b>  {{job.tipo}} - Mesa {{job.comanda.mesa?.nome}}</b>
                        </ng-container>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="info-group">
                      <label>Servidor</label>
                      <span class="info-value">
                        <i class="fe-server"></i>
                        {{job.servidorImpressao?.nome || 'Não atribuído'}}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="info-group">
                      <label>Impressora</label>
                      <span class="info-value">
                        <i class="fe-printer"></i>
                         <ng-container *ngIf="job.impressora.setor != job.impressora.nome">
                                   {{job.impressora.setor}} -
                         </ng-container>
                        {{job.impressora.nome}}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="info-group">
                      <label>Prioridade</label>
                      <span class="info-value">
                        <i class="fe-flag"></i>
                        {{job.prioridade === 1 ? 'Alta' : job.prioridade === 2 ? 'Normal' : 'Baixa'}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-4">
                    <div class="info-group">
                      <label>Criado em</label>
                      <span class="info-value">
                        <i class="fe-calendar"></i>
                        {{job.criadoEm | date:'dd/MM/yyyy HH:mm'}}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="info-group">
                      <label>Concluído em</label>
                      <span class="info-value">
                        <i class="fe-check-circle"></i>
                        {{job.processadoEm ? (job.processadoEm | date:'dd/MM/yyyy HH:mm') : 'Não concluído'}}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="info-group">
                      <label>Tentativas</label>
                      <span class="info-value">
                        <i class="fe-repeat"></i>
                        {{job.tentativas}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sem Jobs no Histórico -->
          <div class="text-center py-4" *ngIf="!carregandoHistorico && jobsHistorico.length === 0">
            <i class="fe-clock text-muted" style="font-size: 3rem;"></i>
            <p class="mt-2 text-muted">Nenhum job no histórico</p>
            <small class="text-muted">Os jobs concluídos aparecerão aqui</small>
          </div>
        </div>
      </div>

      <!-- Paginação do Histórico -->
      <div class="paginacao-container" *ngIf="totalPaginas > 1">
        <nav aria-label="Paginação do histórico">
          <ul class="pagination justify-content-center">
            <li class="page-item" [class.disabled]="paginaAtual === 1">
              <a class="page-link" (click)="irParaPagina(paginaAtual - 1)">Anterior</a>
            </li>
            <li class="page-item" *ngFor="let pagina of [].constructor(totalPaginas); let i = index"
                [class.active]="(i + 1) === paginaAtual">
              <a class="page-link" (click)="irParaPagina(i + 1)">{{i + 1}}</a>
            </li>
            <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
              <a class="page-link" (click)="irParaPagina(paginaAtual + 1)">Próximo</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

</div>
